
import { BasicComboboxEvent } from "@goodgamestudios/core";
import { Balancing } from "../../../constants/shared/Balancing";
import { CreateTablesVO } from "../../../gamevo/CreateTablesVO";
import { Poker2Model } from "../../../model/Poker2Model";
import { Poker2Dialog } from "../Poker2Dialog";
import { Poker2CreateTableDialogProperties } from "./Poker2CreateTableDialogProperties";

import { NumberStringHelper } from "../../../helper/NumberStringHelper";

import Container = createjs.Container;
import MouseEvent = createjs.MouseEvent;

export class Poker2CreateTableDialog extends Poker2Dialog {
    public static NAME: string = "Poker2CreateTableDialog";
    private tableVO: CreateTablesVO;
    private blindsComboBox: Poker2DynamicCombobox;
    private playerComboBox: Poker2DynamicCombobox;
    private helpComboBox: Poker2DynamicCombobox;
    private timeDrawComboBox: Poker2DynamicCombobox;

    constructor(disp: Container) {
        super(disp);
        this.blindsComboBox = new Poker2DynamicCombobox(this.createTableDialog.combo_blinds, "", 4);
        this.playerComboBox = new Poker2DynamicCombobox(this.createTableDialog.combo_player, "", 2);
        this.helpComboBox = new Poker2DynamicCombobox(this.createTableDialog.combo_help, "", 2);
        this.timeDrawComboBox = new Poker2DynamicCombobox(this.createTableDialog.combo_time_draw, "", 3);
        this.initComponents();
    }
    protected applyProperties(): void {
        this.blindsComboBox.disp.addEventListener(BasicComboboxEvent.COMBOBOXCHANGE, this.bindFunction(this.onBlindsComboboxChange));
        this.playerComboBox.disp.addEventListener(BasicComboboxEvent.COMBOBOXCHANGE, this.bindFunction(this.onPlayerComboboxChange));
        this.helpComboBox.disp.addEventListener(BasicComboboxEvent.COMBOBOXCHANGE, this.bindFunction(this.onHelpComboboxChange));
        this.timeDrawComboBox.disp.addEventListener(BasicComboboxEvent.COMBOBOXCHANGE, this.bindFunction(this.onTimeDrawComboboxChange));
        this.initTextFields();
        this.tableVO = new CreateTablesVO();
        this.tableVO.help = true;
        this.tableVO.sBlind = 1;
        this.tableVO.bBlind = 2;
        this.tableVO.actionTime = 5;
        this.tableVO.fOnly = true;
        this.createTableDialog.txt_cost_value.text = NumberStringHelper.groupString(5, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData));
    }
    public hide(): void {
        this.blindsComboBox.disp.removeEventListener(BasicComboboxEvent.COMBOBOXCHANGE, this.bindFunction(this.onBlindsComboboxChange));
        this.playerComboBox.disp.removeEventListener(BasicComboboxEvent.COMBOBOXCHANGE, this.bindFunction(this.onPlayerComboboxChange));
        this.helpComboBox.disp.removeEventListener(BasicComboboxEvent.COMBOBOXCHANGE, this.bindFunction(this.onHelpComboboxChange));
        this.timeDrawComboBox.disp.removeEventListener(BasicComboboxEvent.COMBOBOXCHANGE, this.bindFunction(this.onTimeDrawComboboxChange));

        super.hide();
    }
    private initComponents(): void {
        this.createTableDialog.bg.doCache(0, Poker2LayoutManager.GAME_SCALE_FACTOR);

        this.blindsComboBox.addItem({ label: "100/200" });
        this.blindsComboBox.addItem({ label: "50/100" });
        this.blindsComboBox.addItem({ label: "10/20" });
        this.blindsComboBox.addItem({ label: "1/2" });
        this.helpComboBox.addItem({ label: Poker2Model.languageData.getTextById("lobby_combo_help_0") });
        this.helpComboBox.addItem({ label: Poker2Model.languageData.getTextById("lobby_combo_help_1") });
        this.playerComboBox.addItem({ label: Poker2Model.languageData.getTextById("create_table_combo_player_0") });
        this.playerComboBox.addItem({ label: Poker2Model.languageData.getTextById("create_table_combo_player_1") });
        this.timeDrawComboBox.addItem({ label: "30s" });
        this.timeDrawComboBox.addItem({ label: "15s" });
        this.timeDrawComboBox.addItem({ label: "5s" });
        this.blindsComboBox.defaultString = "100/200";
        this.playerComboBox.defaultString = Poker2Model.languageData.getTextById("create_table_combo_player_0");
        this.helpComboBox.defaultString = Poker2Model.languageData.getTextById("lobby_combo_help_0");
        this.timeDrawComboBox.defaultString = "30s";
    }
    private onBlindsComboboxChange(event: BasicComboboxEvent): void {
        if (this.blindsComboBox.selectedId == 0) {
            this.tableVO.sBlind = 100;
            this.tableVO.bBlind = 200;
        } else if (this.blindsComboBox.selectedId == 1) {
            this.tableVO.sBlind = 50;
            this.tableVO.bBlind = 100;
        } else if (this.blindsComboBox.selectedId == 2) {
            this.tableVO.sBlind = 10;
            this.tableVO.bBlind = 20;
        } else if (this.blindsComboBox.selectedId == 3) {
            this.tableVO.sBlind = 1;
            this.tableVO.bBlind = 2;
        }
    }
    private onPlayerComboboxChange(event: BasicComboboxEvent): void {
        if (this.playerComboBox.selectedId == 0)
            this.tableVO.fOnly = true;
        else
            this.tableVO.fOnly = false;
    }
    private onHelpComboboxChange(event: BasicComboboxEvent): void {
        if (this.helpComboBox.selectedId == 0)
            this.tableVO.help = true;
        else
            this.tableVO.help = false;
    }
    private onTimeDrawComboboxChange(event: BasicComboboxEvent): void {
        if (this.timeDrawComboBox.selectedId == 0)
            this.tableVO.actionTime = 30;
        else if (this.timeDrawComboBox.selectedId == 1)
            this.tableVO.actionTime = 15;
        else if (this.timeDrawComboBox.selectedId == 2)
            this.tableVO.actionTime = 5;
    }
    private initTextFields(): void {
        this.createTableDialog.btn_close.label = Poker2Model.languageData.getTextById("generic_btn_goback");
        this.createTableDialog.btn_ok.label = Poker2Model.languageData.getTextById("lobby_btn_create_table");
        this.createTableDialog.txt_blinds.text = Poker2Model.languageData.getTextById("create_table_blinds");
        this.createTableDialog.txt_cost.text = Poker2Model.languageData.getTextById("create_table_cost");
        this.createTableDialog.txt_help.text = Poker2Model.languageData.getTextById("create_table_help");
        this.createTableDialog.txt_options.text = Poker2Model.languageData.getTextById("create_table_options");
        this.createTableDialog.txt_players.text = Poker2Model.languageData.getTextById("create_table_players");
        this.createTableDialog.txt_time_draw.text = Poker2Model.languageData.getTextById("create_table_draw");
        this.createTableDialog.txt_title.text = Poker2Model.languageData.getTextById("create_table_title");
        this.createTableDialog.txt_tabel_name_value.text = Poker2Model.languageData.getTextById("create_table_name_value");
    }
    protected onClick(event: MouseEvent): void {
        super.onClick(event);
        switch (event.target) {
            case this.createTableDialog.btn_close:
                this.hide();
                break;
            case this.createTableDialog.btn_ok:
                this.hide();
                if (this.createTableDialogProperties.functionOk != null)
                    this.createTableDialogProperties.functionOk(this.tableVO);
                break;
        }
    }
    protected get createTableDialogProperties(): Poker2CreateTableDialogProperties {
        return this.properties as Poker2CreateTableDialogProperties;
    }

    protected get createTableDialog(): Library.PokerInterface.PokerCreateTable {
        return this.disp as Library.PokerInterface.PokerCreateTable;
    }
}
import {Poker2DynamicCombobox} from "../../components/Poker2DynamicCombobox";
import {Poker2LayoutManager} from "../../Poker2LayoutManager";
